import { get } from 'global/lib/lodash';
import React from 'react';
import { Row } from 'global/components/row';
import { Text } from 'global/components/text';
import { percentify, uppercaseFirst } from 'global/utils';
import { StyledRow } from './styles';
import moment from 'moment';
import { BorderLinearProgress } from '../courses';
import { useScreen } from 'global/styles';
import { withRouter } from 'react-router-dom';

const cols = [
  { title: 'Student', val: (p) => get(p, 'item.user.name', get(p, 'item.user.email', '')) },
  { title: 'Exercise', val: (p) => uppercaseFirst(get(p, 'item.assessment.status', 'None') || 'None') },
  { title: 'Updated', val: (p) => moment(get(p, 'item.updatedAt', '')).format('L') },
];

export const ListItem = withRouter((props) => {
  const { isMobile } = useScreen();
  const effIsMobile = isMobile || props.isMobile;

  const { edition, id } = props.item;

  const completion = get(props, 'item.completion');

  const compValue = (() => {
    let text = '';
    let value = completion;
    let style = {};

    if (value === null) {
      text = 'Not Started';
      value = 0;
      style = { fontStyle: 'italic' };
    } else if (value >= 100) {
      text = 'Finished';
      style = { fontStyle: 'italic' };
    } else {
      text = `${percentify(value)} Complete`;
    }

    return { text, value, style };
  })();

  const onClick = () => {
    props.history.push(`/courses/${id}`, get(props, 'location.state', {}));
  };

  const showSecondRow = get(props, 'showSecondRow', true);

  return (
    <StyledRow isMobile={effIsMobile} disabled={props.disabled} onClick={onClick}>
      <Row fullWidth className="firstRow">
        <Text type="title_medium" bold>
          {get(edition, 'name', 'N/A')}
        </Text>
        <Text style={{ marginLeft: 'auto', ...compValue.style }} type="title_medium" bold>
          {compValue.text}
        </Text>
      </Row>
      <div className="progBar">
        <BorderLinearProgress variant="determinate" value={compValue.value} />
      </div>
      {showSecondRow && (
        <Row className="secondRow">
          {cols.map((col) => (
            <div key={col.title} className="col">
              <Text type="label_small">{col.title}</Text>
              <Text type="title_small">{col.val(props)}</Text>
            </div>
          ))}
        </Row>
      )}
    </StyledRow>
  );
});
